import { Component, OnInit } from '@angular/core';
import { STAFF } from './staff.config';

@Component({
  selector: 'pda-staff',
  templateUrl: './staff.component.html',
  styleUrls: ['./staff.component.scss']
})
export class StaffComponent implements OnInit {

  config = {
    defaultImage: '/assets/images/staff/staff.webp',
    items: STAFF
  };

  constructor() { }

  ngOnInit(): void {
  }

}
